<template>
  <div class="marketplace_registration_header">
    <div class="top_header_wrapper">
      <div class="top_header_inner">
        <div class="vivense_logo">
          <router-link :to="{ name: 'home' }">
            <img src="~@/assets/images/vivense-new-logo.svg" :alt="appTitle" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    const { VUE_APP_TITLE, VUE_APP_VIVENSE_URL } = process.env;
    return {
      appTitle: VUE_APP_TITLE,
      vivenseUrl: VUE_APP_VIVENSE_URL,
    };
  },
};
</script>
